"use client"

import { useEffect } from "react"
import { Center, Stack, Title, Text, Button, Alert } from "@forestsync/ui"
import { TbAlertCircle, TbRefresh } from "react-icons/tb"
import { useTranslations } from "next-intl"

interface ErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

export default function Error({ error, reset }: ErrorProps) {
  const t = useTranslations("errors")

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    // Sits inside AppShell.Main, which already pads for the 60px header — a plain 100vh
    // made the error screen 60px taller than the window and added a pointless scrollbar.
    <Center h="calc(100dvh - var(--app-shell-header-height, 0px))">
      <Stack align="center" gap="md" maw={480} ta="center">
        <Alert
          icon={<TbAlertCircle size={20} />}
          color="red"
          variant="light"
          w="100%"
          title={t("somethingWentWrong")}
        >
          {process.env.NODE_ENV === "development" ? error.message : t("somethingWentWrong")}
        </Alert>
        <Title order={3}>{t("somethingWentWrong")}</Title>
        <Button
          variant="filled"
          leftSection={<TbRefresh size={16} />}
          onClick={reset}
        >
          {t("tryAgain")}
        </Button>
        {error.digest && (
          <Text size="xs" c="dimmed" ff="monospace">
            {t("referenceCode")}: {error.digest}
          </Text>
        )}
      </Stack>
    </Center>
  )
}
